import { Button, Css, useTestIds } from "@homebound/beam";
import { useStepperContext } from "src/components/stepper";
import { ConfigureBidGroupsStepQuery } from "src/routes/bids/plan-based-bid-package/components/2.ConfigureBidGroupsStep.generated";
import { PlanBasedBidPackageStep } from "src/routes/bids/plan-based-bid-package/utils";

type HeaderSectionProps = { bidPackage: ConfigureBidGroupsStepQuery["bidPackage"] };

export function HeaderSection(props: HeaderSectionProps) {
  const { costCodes, costType, projects, productOfferings } = props.bidPackage;
  const { goToStep } = useStepperContext();
  const tid = useTestIds({});
  const costCodeNames = costCodes.map((cc) => cc.name).join(", ");
  return (
    <div css={Css.mb3.$}>
      <div css={Css.xl.mb2.$} {...tid.title}>
        Configure {costCodeNames} bid
      </div>
      <div css={Css.mb3.$}>
        Configure how trades will bid the base scope and add-on options. Your selections create the cost lines in this
        bid.
      </div>
      <div css={Css.smSb.$} {...tid.summary}>
        {costCodeNames} <span css={Css.xs.$}>|</span> {costType.name} <span css={Css.xs.$}>|</span>{" "}
        {projects.map((p) => p.name).join(", ")}
      </div>
      <div {...tid.productOfferings}>
        {/* TODO: render names as tags https://linear.app/homebound-team/issue/P-2487/beam-tag-updates-to-support-creation-flow */}
        {productOfferings.map((pof) => pof.name).join(", ")}{" "}
        <Button variant="tertiary" label="Edit" onClick={() => goToStep(PlanBasedBidPackageStep.DEFINE_PACKAGE)} />
      </div>
    </div>
  );
}
